/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Chat_CollapseInputs */



/**
* | output |
* | --- |
* | "Exit full screen" |
*
* @param {Chat_CollapseInputs} inputs
* @param {{ locale?: "en" | "nl" | "fr" }} options
* @returns {LocalizedString}
*/
export const chat_collapse = /** @type {((inputs?: Chat_CollapseInputs, options?: { locale?: "en" | "nl" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Chat_CollapseInputs, { locale?: "en" | "nl" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return /** @type {LocalizedString} */ ("Verlaat volledig scherm")
	if (locale === "fr") return /** @type {LocalizedString} */ ("Quitter le plein écran")
	return /** @type {LocalizedString} */ ("Exit full screen")
});